import { combineReducers } from 'redux';
import message from './message.reducer';

const messageReducers = combineReducers(Object.assign({
    message
}));

export default messageReducers;
